import { ColumnModel, FilterModel } from '../../filter';

export const AddOnFilterKey = 'ADDON_FILTER';
export const AddOnOrderKey = 'ADDON_ORDER';

export const AddOnFilterColumns = ['media', 'product', 'asset', 'routines', 'createdAt', 'updatedAt'];

export class AddOnFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  columns?: string[];
  workspaceId?: string;

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.columns = data?.columns || ['media', 'product', 'asset', 'routines', 'createdAt', 'updatedAt'];
    this.workspaceId = data?.workspaceId;
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    if (this.workspaceId) {
      filter.workspaceId = this.workspaceId;
    }

    return filter;
  }
}
